/**
 * global variable collection
 */

const globals = {
  blankBase64Image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',

  ceoUserIds: [5605,6014], // Jakob & Carsten

  colors: {
    highlightColor: '#87cc10',
    americanPalette: {
      lightGreenishBlue: '#55efc4',
      fadedPoster: '#81ecec',
      greenDarnerTail: '#74b9ff',
      shyMoment: '#a29bfe',
      cityLights: '#dfe6e9',
      mintLeaf: '#00b894',
      robinsEggBlue: '#00cec9',
      electronBlue: '#0984e3',
      exodusFruit: '#6c5ce7',
      soothingBreeze: '#b2bec3',
      sourLemon: '#ffeaa7',
      firstDate: '#fab1a0',
      pinkGlamour: '#ff7675',
      pico8Pink: '#fd79a8',
      americanRiver: '#636e72',
      brightYarrow: '#fdcb6e',
      orangeVille: '#e17055',
      chiGong: '#d63031',
      prunusAvium: '#e84393',
      draculaOrchid: '#2d3436',
    },
    flatUiPaletteV1: {
      turquoise: '#1abc9c',
      emerald: '#2ecc71',
      peterRiver: '#3498db',
      amethyst: '#9b59b6',
      wetAsphalt: '#34495e',
      greenSea: '#16a085',
      nephritis: '#27ae60',
      belizeHole: '#2980b9',
      wisteria: '#8e44ad',
      midnightBlue: '#2c3e50',
      sunFlower: '#f1c40f',
      carrot: '#e67e22',
      alizarin: '#e74c3c',
      clouds: '#ecf0f1',
      concrete: '#95a5a6',
      orange: '#f39c12',
      pumpkin: '#d35400',
      pomegranate: '#c0392b',
      silver: '#bdc3c7',
      asbestos: '#7f8c8d'
    },
    materialUiColors: {
      red: '#F44336',
      pink: '#E91E63',
      purple: '#9C27B0',
      deepPurple: '#673AB7',
      indigo: '#3F51B5',
      blue: '#2196F3',
      lightBlue: '#03A9F4',
      cyan: '#00BCD4',
      teal: '#009688',
      green: '#4CAF50',
      lightGreen: '#8BC34A',
      lime: '#CDDC39',
      yellow: '#FFEB3B',
      amber: '#FFC107',
      orange: '#FF9800',
      deepOrange: '#FF5722',
      brown: '#795548',
      grey: '#9E9E9E',
      blueGrey: '#607D8B'
    }
  },

  currencies: {
    aed: 'د.إ',
    afn: '؋',
    all: 'L',
    amd: '֏',
    ang: 'ƒ',
    aoa: 'Kz',
    ars: '$',
    aud: '$',
    awg: 'ƒ',
    azn: '₼',
    bam: 'KM',
    bbd: '$',
    bdt: '৳',
    bgn: 'лв',
    bhd: '.د.ب',
    bif: 'FBu',
    bmd: '$',
    bnd: '$',
    bob: '$b',
    brl: 'R$',
    bsd: '$',
    btc: '฿',
    btn: 'Nu.',
    bwp: 'P',
    byn: 'Br',
    byr: 'Br',
    bzd: 'BZ$',
    cad: '$',
    cdf: 'FC',
    chf: 'CHF',
    clp: '$',
    cny: '¥',
    cop: '$',
    crc: '₡',
    cuc: '$',
    cup: '₱',
    cve: '$',
    czk: 'Kč',
    djf: 'Fdj',
    dkk: 'kr',
    dop: 'RD$',
    dzd: 'دج',
    eek: 'kr',
    egp: '£',
    ern: 'Nfk',
    etb: 'Br',
    eth: 'Ξ',
    eur: '€',
    fjd: '$',
    fkp: '£',
    gbp: '£',
    gel: '₾',
    ggp: '£',
    ghc: '₵',
    ghs: 'GH₵',
    gip: '£',
    gmd: 'D',
    gnf: 'FG',
    gtq: 'Q',
    gyd: '$',
    hkd: '$',
    hnl: 'L',
    hrk: 'kn',
    htg: 'G',
    huf: 'Ft',
    idr: 'Rp',
    ils: '₪',
    imp: '£',
    inr: '₹',
    iqd: 'ع.د',
    irr: '﷼',
    isk: 'kr',
    jep: '£',
    jmd: 'J$',
    jod: 'JD',
    jpy: '¥',
    kes: 'KSh',
    kgs: 'лв',
    khr: '៛',
    kmf: 'CF',
    kpw: '₩',
    krw: '₩',
    kwd: 'KD',
    kyd: '$',
    kzt: 'лв',
    lak: '₭',
    lbp: '£',
    lkr: '₨',
    lrd: '$',
    lsl: 'M',
    ltc: 'Ł',
    ltl: 'Lt',
    lvl: 'Ls',
    lyd: 'LD',
    mad: 'MAD',
    mdl: 'lei',
    mga: 'Ar',
    mkd: 'ден',
    mmk: 'K',
    mnt: '₮',
    mop: 'MOP$',
    mro: 'UM',
    mru: 'UM',
    mur: '₨',
    mvr: 'Rf',
    mwk: 'MK',
    mxn: '$',
    myr: 'RM',
    mzn: 'MT',
    nad: '$',
    ngn: '₦',
    nio: 'C$',
    nok: 'kr',
    npr: '₨',
    nzd: '$',
    omr: '﷼',
    pab: 'B/.',
    pen: 'S/.',
    pgk: 'K',
    php: '₱',
    pkr: '₨',
    pln: 'zł',
    pyg: 'Gs',
    qar: '﷼',
    rmb: '￥',
    ron: 'lei',
    rsd: 'Дин.',
    rub: '₽',
    rwf: 'R₣',
    sar: '﷼',
    sbd: '$',
    scr: '₨',
    sdg: 'ج.س.',
    sek: 'kr',
    sgd: '$',
    shp: '£',
    sll: 'Le',
    sos: 'S',
    srd: '$',
    ssp: '£',
    std: 'Db',
    stn: 'Db',
    svc: '$',
    syp: '£',
    szl: 'E',
    thb: '฿',
    tjs: 'SM',
    tmt: 'T',
    tnd: 'د.ت',
    top: 'T$',
    trl: '₤',
    try: '₺',
    ttd: 'TT$',
    tvd: '$',
    twd: 'NT$',
    tzs: 'TSh',
    uah: '₴',
    ugx: 'USh',
    usd: '$',
    uyu: '$U',
    uzs: 'лв',
    vef: 'Bs',
    vnd: '₫',
    vuv: 'VT',
    wst: 'WS$',
    xaf: 'FCFA',
    xbt: 'Ƀ',
    xcd: '$',
    xof: 'CFA',
    xpf: '₣',
    yer: '﷼',
    zar: 'R',
    zwd: 'Z$'
  },

  customerService: {
    phone: '004962579429530',
    phoneFormatted: '+49 6257 94295-30',
    email: 'support@mundus-agri.eu'
  },

  dateFormats: {
    'de': 'd.m.Y',
    'en': 'Y-m-d',
    'ru': 'd.m.Y',
    'tr': 'd.m.Y'
  },

  dateTimeFormats: {
    'de': 'd.m.Y H:i',
    'en': 'Y-m-d H:i',
    'ru': 'd.m.Y H:i',
    'tr': 'd.m.Y H:i'
  },

  dedereCompanyIds: [151, 307, 1184], // Auditor, Marketplace, Dedere
  developerUserIds: [408, 3159], // Dirk, Mehrez
  editAddressResponsibleIds: [408, 3159, 5605, 6014, 9439], // Dirk, Mehrez, Jakob, Carsten, Logan

  googleMaps: {
    apiKey: 'AIzaSyApMGkZCn0A_aV7hmO8uH1DEpYvVuY7nSY',
    valueAddedStepsMarkerIcons: {
      1: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',  // Farmer
      2: 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png', // Händler
      3: 'https://maps.google.com/mapfiles/ms/icons/pink-dot.png',   // Trader
      4: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',    // produzierendes Gewerbe
      5: 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png', // verarbeitendes Gewerbe
      6: 'https://maps.google.com/mapfiles/ms/icons/purple-dot.png', // Broker
      7: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png'    // Dienstleistungen
    }
  },

  langFlagMap: {
    'en': 'gb'
  },

  mimeTypes: {
    zip: 'application/zip', // zip
    rar: 'application/zip', // rar
    pdf: 'application/pdf', // pdf
    doc: 'application/msword', // doc
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', //'docx',
    xls: 'application/msexcel', // xls
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xlsx
    ppt: 'application/mspowerpoint', // ppt
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', // pptx
    jpg: 'image/jpeg', // jpg
    jpeg: 'image/jpeg', // jpeg
    png: 'image/png', // png
    gif: 'image/gif', // gif
    bmp: 'image/bmp', // bmp
    csv: 'application/vnd.ms-excel', // csv
    txt: 'text/plain' // txt
  },

  validationRules: {
    tax: {
      'at': {
        pattern: /^ATU\d{8}$/i,
        html5Pattern: '^[aA][tT][uU]\\d{8}$',
        examples: ['ATU99999999']
      },
      'be': {
        pattern: /^BE\d{10}$/i,
        html5Pattern: '^[bB][eE]\\d{10}$',
        examples: ['BE0999999999', 'BE9999999999']
      },
      'bg': {
        pattern: /^BG\d{9,10}$/i,
        html5Pattern: '^[bB][gG]\\d{9,10}$',
        examples: ['BG999999999', 'BG9999999999']
      },
      'cy': {
        pattern: /^CY\d{8}[A-Z]$/i,
        html5Pattern: '^[cC][yY]\\d{8}[a-zA-Z]$',
        examples: ['CY99999999L']
      },
      'cz': {
        pattern: /^CZ\d{8,10}$/i,
        html5Pattern: '^[cC][zZ]\\d{8, 10}$',
        examples: ['CZ99999999', 'CZ999999999', 'CZ9999999999']
      },
      'de': {
        pattern: /^DE\d{9}$/i,
        html5Pattern: '^[dD][eE]\\d{9}$',
        examples: ['DE999999999']
      },
      'dk': {
        pattern: /^DK\d{8}$/i,
        html5Pattern: '^[dD][kK]\\d{8}$',
        examples: ['DK99999999']
      },
      'ee': {
        pattern: /^EE\d{9}$/i,
        html5Pattern: '^[eE][eE]\\d{9}$',
        examples: ['EE999999999']
      },
      'el': {
        pattern: /^EL\d{9}$/i,
        html5Pattern: '^[eE][lL]\\d{9}$',
        examples: ['EL012345678']
      },
      'es': {
        pattern: /^ES[A-Z]\d{7}[A-Z]$|^ES[A-Z]\d{8}$|^ES\d{8}[A-Z]$/i,
        html5Pattern: '^[eE][sS]\\d{7}[a-zA-Z]$|[eE][sS][a-zA-Z]\\d{8}$|[eE][sS]\\d{8}[a-zA-Z]$',
        examples: ['ESX9999999X', 'ESX99999999', 'ES99999999X']
      },
      'fi': {
        pattern: /^FI\d{8}$/i,
        html5Pattern: '^[fF][iI]\\d{8}$',
        examples: ['FI99999999']
      },
      'fr': {
        pattern: /^[fF][rR][0-9a-zA-Z][0-9a-zA-Z]\d{8}$/i,
        html5Pattern: '^[fF][rR][0-9A-Z]\\d{8}$',
        examples: ['FRXX999999999']
      },
      'gb': {
        pattern: /^GB\d{9}(\d{3})?$|^GB(GD|HA)\d{3}$/i,
        html5Pattern: '^[gG][bB]\\d{9}(\\d{3})?$|^[gG][bB]([gG][dD]|[hH][aA])\\d{3}$',
        examples: ['GB999999999', 'GB999999999999', 'GBGD999', 'GBHA999']
      },
      'gr': {
        pattern: /^EL\d{9}$/i,
        html5Pattern: '^[eE][lL]\\d{9}$',
        examples: ['EL999999999']
      },
      'hr': {
        pattern: /^HR\d{11}$/i,
        html5Pattern: '^[hH][rR]\\d{11}$',
        examples: ['HR99999999999']
      },
      'hu': {
        pattern: /^HU\d{8}$/i,
        html5Pattern: '^[hH][uU]\\d{8}$',
        examples: ['HU99999999']
      },
      'ie': {
        pattern: /^IE\d[0-9A-Z]\d{5}[A-Z]$|^IE\d{7}[A-W][A-I]$/i,
        html5Pattern: '^[iI][eE]\\d[0-9a-zA-Z]\d{5}[a-zA-Z]$|^[iI][eE]\\d{7}[a-wA-W][a-iA-I]$',
        examples: ['IE9S99999L', 'IE9999999LI']
      },
      'it': {
        pattern: /^IT\d{11}$/i,
        html5Pattern: '^[iI][tT]\\d{11}$',
        examples: ['IT99999999999']
      },
      'lt': {
        pattern: /^LT\d{9}(\d{3})?$/i,
        html5Pattern: '^[lL][tT]\\d{9}(\\d{3})?$',
        examples: ['LT999999999', 'LT999999999999']
      },
      'lu': {
        pattern: /^LU\d{8}$/i,
        html5Pattern: '^[lL][uU]\\d{8}$',
        examples: ['LU99999999']
      },
      'lv': {
        pattern: /^LV\d{11}$/i,
        html5Pattern: '^[lL][vV]\\d{11}$',
        examples: ['LV99999999999']
      },
      'mt': {
        pattern: /^MT\d{8}$/i,
        html5Pattern: '^[mM][tT]\\d{8}$',
        examples: ['MT99999999']
      },
      'nl': {
        pattern: /^NL\d{9}B\d{2}$/i,
        html5Pattern: '^[nN][lL]\\d{9}[bB]\\d{2}$',
        examples: ['NL999999999B99']
      },
      'pl': {
        pattern: /^PL\d{10}$/i,
        html5Pattern: '^[pP][lL]\\d{10}$',
        examples: ['PL9999999999']
      },
      'pt': {
        pattern: /^PT\d{9}$/i,
        html5Pattern: '^[pP][tT]\\d{9}$',
        examples: ['PT999999999']
      },
      'ro': {
        pattern: /^RO[1-9]\d{1,9}$/i,
        html5Pattern: '^[rR][oO][1-9]\\d{1,9}$',
        examples: ['RO999999999']
      },
      'se': {
        pattern: /^SE\d{10}01$/i,
        html5Pattern: '^[sS][eE]\\d{10}01$',
        examples: ['SE999999999901']
      },
      'si': {
        pattern: /^SI\d{8}$/i,
        html5Pattern: '^[sS][iI]\\d{8}$',
        examples: ['SI99999999']
      },
      'sk': {
        pattern: /^SK\d{10}$/i,
        html5Pattern: '^[sS][kK]\\d{10}$',
        examples: ['SK9999999999']
      },
    },
  },
};

export default globals;

const blankBase64Image = globals.blankBase64Image;
const colors = globals.colors;
const americanPalette = colors.americanPalette;
const flatUiPaletteV1 = colors.flatUiPaletteV1;
const materialUiColors = colors.materialUiColors;

const langFlagMap = globals.langFlagMap;
const mimeTypes = globals.mimeTypes;
const ceoUserIds = globals.ceoUserIds;
const currencies = globals.currencies;

const customerService = globals.customerService;

const dateFormats = globals.dateFormats;
const dateTimeFormats = globals.dateTimeFormats;
const dedereCompanyIds = globals.dedereCompanyIds;
const developerUserIds = globals.developerUserIds;
const editAddressResponsibleIds = globals.editAddressResponsibleIds;

const googleMaps = globals.googleMaps;
const valueAddedStepsMarkerIcons = globals.googleMaps.valueAddedStepsMarkerIcons;

const validationRules = globals.validationRules;
const taxValidationRules = globals.validationRules.tax;

export {
  globals,

  americanPalette,
  blankBase64Image,
  colors,
  flatUiPaletteV1,
  materialUiColors,

  langFlagMap,
  mimeTypes,
  ceoUserIds,
  currencies,
  customerService,
  dateFormats,
  dateTimeFormats,
  dedereCompanyIds,
  developerUserIds,
  editAddressResponsibleIds,

  googleMaps,
  valueAddedStepsMarkerIcons,

  validationRules,
  taxValidationRules
};